import { Injectable, EventEmitter } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../core/shared/classes/api';

@Injectable()
export class LocalisationService {

    constructor (private apiService: ApiService) {}

    getPays(): Observable<ApiResponse> {
        return this.apiService.get('pays');
    }

    getZonesGeographiques(): Observable<ApiResponse> {
        return this.apiService.get('zones-geographiques');
    }

    getVilles(payId?: string, searchTerm?: string, withAcl?: string, query?: {page: number, perPage: number}): Observable<ApiResponse> {
        return this.apiService.get('ville' + (payId ? '/pays/' + payId : '') + (searchTerm ? '/search/' + searchTerm : '') + (withAcl ? '/acl/' + withAcl : ''), {}, query);
    }

    getZones(payId?: string, withAcl?: string): Observable<ApiResponse> {
        return this.apiService.get('zone' + (payId ? '/pays/' + payId : '') + (withAcl ? '/acl/' + withAcl : ''));
    }

    insertZone(data: any): Observable<ApiResponse> {
        return this.apiService.post('zone', data);
    }

    updateZone(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('zone/' + id, data);
    }

    deleteZone(id: string): Observable<ApiResponse> {
        return this.apiService.delete('zone/' + id);
    }

    insertVille(data: any): Observable<ApiResponse> {
        return this.apiService.post('ville', data);
    }

    updateVille(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('ville/' + id, data);
    }

    deleteVille(id: string): Observable<ApiResponse> {
        return this.apiService.delete('ville/' + id);
    }
}
